import { LayoutDashboard } from "lucide-react"

import { lazyPage } from "../lazy-page"
import { defineDashboardModule } from "../types"

export const home = defineDashboardModule({
  id: "home",
  nav: [
    { group: "Overview", title: "Dashboard", to: "/", icon: LayoutDashboard },
  ],
  routes: [
    {
      path: "/",
      component: lazyPage(() => import("@/routes/home"), "HomePage"),
    },
  ],
})
